import {
  digitalVariables,
  getProduct,
  getSourceUrlWithQuerys,
  formatters,
  storage,
  facebook
} from '@itau-loans-www/utils'

import sdkAnalytics from '../third-party/skd-analytics'
import auth from './auth'
import { defaultLeadsApiCall } from './utils'

const product = getProduct()

const productId = {
  fgts: 5,
  consignado: 6
}

const newCreateLead = async ({
  name,
  cpf,
  email,
  phone,
  recaptcha,
  partner,
  vwo,
  ...args
}) => {
  const additionalData = await digitalVariables.get()
  const source_url = getSourceUrlWithQuerys(vwo) ?? ''
  const requestBody = {
    lead_name: name,
    document_number: cpf,
    email: email,
    phone_number: phone,
    product_id: productId[product],
    source_url,
    partner,
    additional_data: additionalData,
    ...args
  }

  const request = await auth({}).then((_http) =>
    _http.post(`v2/itau-loans-api/leads/create`, requestBody, {
      headers: { ...(recaptcha && { 'g-recaptcha-response': recaptcha }) }
    })
  )

  const { data } = request

  const token = {
    accessToken: data.auth['token'],
    startDate: data.auth['server_time'],
    validTime: data.auth['valid_time'],
    leadId: data.id
  }

  const leadId = storage.session.getItem('token')?.leadId

  if (!leadId) {
    sdkAnalytics.track('setUserProperties', data.id)

    if (product === 'fgts') {
      sdkAnalytics.track('trackClick', 'btn:consultar')
      sdkAnalytics.track('trackEvent', {
        event_name: 'engagement',
        parameters: {
          custom_path: '/fgts/saque-aniversario/home',
          detail: 'tela-inicial-fgts-antecipacao-conhecer-oferta'
        }
      })
    }

    if (product === 'consignado') {
      sdkAnalytics.track('trackEvent', {
        event_name: 'engagement',
        parameters: {
          custom_path: '/emprestimo/consignado/home',
          detail: 'tela-inicial-emprestimo-consignado-itau-conhecer-oferta'
        }
      })
    }
  }

  storage.session.setItem('token', JSON.stringify(token))

  return data
}

const postSendSms = async () => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'send_sms_code',
    method: 'post'
  })

  return data
}

const postSmsToken = async (requestBody) => {
  const tokensAtstore = storage.session.getItem('token')

  const { data } = await defaultLeadsApiCall({
    endpoint: 'authentication',
    method: 'post',
    body: requestBody
  })

  const authentication = data.auth

  const token = {
    ...tokensAtstore,
    accessToken: authentication['token'],
    startDate: authentication['server_time'],
    validTime: authentication['valid_time']
  }

  storage.session.setItem('token', JSON.stringify(token))

  return data
}

const getStepInfo = async () => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'step_info',
    method: 'get'
  })

  return data
}

const getSimulationSummary = async () => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'simulation_summary',
    method: 'get'
  })

  return data
}

const getProperty = async () => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'property',
    method: 'get'
  })

  return data
}

const getPurposeData = async () => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'purpose_data',
    method: 'get'
  })

  return data
}

const getOccupation = async () => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'occupation',
    method: 'get'
  })

  return data
}

const getProposals = async () => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'proposals',
    method: 'get'
  })

  return data
}

const finishSimulation = async (productCode, requestBody = {}) => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'simulation_summary',
    method: 'post',
    body: requestBody
  })

  facebook.trackLeadComplete(productCode)

  return data
}

const finishSimulationOnWpp = async (productCode) => {
  const simulationOptionUuid = storage.session.getItem('simulationOptionUuid')

  const { data } = await defaultLeadsApiCall({
    endpoint: 'proposals',
    method: 'post',
    body: {
      contact_type: 'whatsapp',
      simulation_option_uuid: simulationOptionUuid,
      inbound: true
    }
  })

  facebook.trackLeadComplete(productCode)

  return data
}

const sendSmsAgain = async () => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'send_finished_sms',
    method: 'post'
  })

  return data
}

const editProposalData = async (offerUuid, requestBody) => {
  const formatedBody = {
    loan_value: formatters.number.currencyToFloat(requestBody.value),
    ...(requestBody.installmentsValue && {
      installments_value: formatters.number.currencyToFloat(
        requestBody.installmentsValue.toString()
      )
    }),
    ...(requestBody.installmentsNumber && {
      installments_number: Number(
        formatters.misc.removeNonNumericCharacters(
          requestBody.installmentsNumber.toString()
        )
      )
    }),
    ...(requestBody.dueDate && {
      due_date: formatters.date.toISO(requestBody.dueDate)
    })
  }

  const { data } = await defaultLeadsApiCall({
    endpoint: `${offerUuid}/simulations`,
    method: 'put',
    body: formatedBody
  })

  return data
}

const finishFGTSProposal = async (
  contactType = 'whatsapp',
  simulationOptionUuid = '',
  productCode = 'FGTS'
) => {
  const { data } = await defaultLeadsApiCall({
    endpoint: product === 'fgts' ? 'proposals' : 'simulation_summary',
    method: product === 'fgts' ? 'post' : 'put',
    body: {
      contact_type: contactType,
      simulation_option_uuid: simulationOptionUuid
    }
  })

  facebook.trackLeadComplete(productCode)

  return data
}

const crossSell = async () => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'cross-sell',
    method: 'post'
  })

  return data
}

const getLeadPhone = async (args) => {
  const isToRemoveHash = args?.removeHash
  const hashFlag = isToRemoveHash ? '?hash=false' : ''

  const { data } = await defaultLeadsApiCall({
    endpoint: `send_sms_code/${hashFlag}`,
    method: 'get'
  })

  return data
}

const getAgreementState = async (agreement_type_id) => {
  const { data } = await auth({}).then((_http) => {
    return _http.get(
      `v2/itau-loans-api/agreement/type/${agreement_type_id}/state/`,
      {}
    )
  })

  return data
}

const putAgreementData = async (requestBody) => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'agreement',
    method: 'put',
    body: requestBody
  })

  return data
}

const getAgreementData = async () => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'agreement',
    method: 'get'
  })

  return data
}

const getBanks = async (product) => {
  // TO DO: entender porque em alguns casos o consig_ncor vem como undefined
  const url = `v2/itau-loans-api/banks/${
    product === 'FGTS' ? '?product_code=FGTS' : '?product_code=consig_ncor'
  }`

  const { data } = await auth({}).then((_http) => _http.get(url))

  return data
}

const getNextStepBlocked = async (productCode) => {
  const { data } = await defaultLeadsApiCall({
    endpoint: `step-blocked-offer/?product=${productCode}`,
    method: 'get'
  })

  return data
}

const putSimulationSummary = async (requestBody) => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'simulation_summary',
    method: 'put',
    body: requestBody
  })

  return data
}

const putDesiredLoanData = async (requestBody) => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'desired_loan_data',
    method: 'put',
    body: requestBody
  })

  return data
}

const putProperty = async (requestBody) => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'property',
    method: 'put',
    body: requestBody
  })

  return data
}

const putPurposeData = async (requestBody) => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'purpose_data',
    method: 'put',
    body: requestBody
  })

  return data
}

const putOccupation = async (requestBody) => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'occupation',
    method: 'put',
    body: requestBody
  })

  return data
}

const getPendingPhoto = async () => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'pending-photo',
    method: 'get'
  })

  return data
}

const putPendingPhoto = async (requestBody) => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'pending-photo',
    method: 'put',
    body: requestBody
  })

  return data
}

const getPendingData = async () => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'pending-data',
    method: 'get'
  })

  return data
}

const putPendingData = async (requestBody) => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'pending-data',
    method: 'put',
    body: requestBody
  })

  return data
}

const getPendingFormalization = async () => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'pending-formalization',
    method: 'get'
  })

  return data
}

const putPendingFormalization = async (requestBody) => {
  const { data } = await defaultLeadsApiCall({
    endpoint: 'pending-formalization',
    method: 'put',
    body: requestBody
  })

  return data
}

export default {
  newCreateLead,
  postSendSms,
  sendSmsAgain,
  postSmsToken,
  getStepInfo,
  finishSimulation,
  finishSimulationOnWpp,
  finishFGTSProposal,
  editProposalData,
  crossSell,
  getLeadPhone,
  getAgreementState,
  putAgreementData,
  getBanks,
  getAgreementData,
  getNextStepBlocked,
  getSimulationSummary,
  getProposals,
  getProperty,
  getPurposeData,
  getOccupation,
  putSimulationSummary,
  putDesiredLoanData,
  putProperty,
  putPurposeData,
  putOccupation,
  getPendingPhoto,
  putPendingPhoto,
  getPendingData,
  putPendingData,
  getPendingFormalization,
  putPendingFormalization
}
